<template>
  <div v-if="isMounted">
    <svg
      :style="[{ 'pointer-events': readOnly ? 'none' : 'fill' }]"
      :height="height"
      :width="width"
      fill="none"
      viewBox="0 0 422 786"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        @click="eventClickOnGerericAreas(areas.face)"
        @mouseover="activeArea = areas.face"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :fill="data.face.selected ? areas.face.activeColor : areas.face.inactiveColor"
        :class="{ active: data.face.selected, hovered: activeArea == areas.face }"
        class="ax-selectable"
        d="M261.5 23C291 49 295.5 74 280 112.5C284.47 108.665 288 108.5 291 112.5C292.34 122.113 290.97 127.127 282.5 135C278.977 141.832 277.354 146.012 275.5 154.5C273.157 156.184 271.843 156.551 269.5 154.5C264.895 166.674 261.34 172.458 251 178.5C243.075 179.258 238.122 180.849 228.5 185.5C215.227 193.4 207.948 194.503 195.5 185.5L173.5 178.5C165.5 174.5 156.548 169.602 153.5 154.5C151.696 156.087 150.901 155.555 149.5 154.5C141 131.5 129.857 130.692 131.5 115C137.117 105.867 141.31 108.938 149.5 120C144 109 136.593 107.694 135 95C133.778 67.2865 133.797 52.5891 144 38.5C155.109 26.7895 161.901 21.1735 176 14.5C182.301 12.9699 188.09 11.6946 193.5 10.7176C196.617 10.1547 199.609 9.69075 202.5 9.33421C205.073 9.01687 207.567 8.78459 210 8.64325C212.04 8.52474 214.036 8.47017 216 8.48299C217.934 7.44385 217.795 5.36797 217 1L219.5 8.57949C233.524 9.26946 246.164 13.6327 261.5 23Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.face)"
        @mouseover="activeArea = areas.face"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M219.5 8.57949C233.524 9.26946 246.164 13.6327 261.5 23C291 49 295.5 74 280 112.5C284.47 108.665 288 108.5 291 112.5C292.34 122.113 290.97 127.127 282.5 135C278.977 141.832 277.354 146.012 275.5 154.5C273.157 156.184 271.843 156.551 269.5 154.5C264.895 166.674 261.34 172.458 251 178.5C243.075 179.258 238.122 180.849 228.5 185.5C215.227 193.4 207.948 194.503 195.5 185.5L173.5 178.5C165.5 174.5 156.548 169.602 153.5 154.5C151.696 156.087 150.901 155.555 149.5 154.5C141 131.5 129.857 130.692 131.5 115C137.117 105.867 141.31 108.938 149.5 120C144 109 136.593 107.694 135 95C133.778 67.2865 133.797 52.5891 144 38.5C155.109 26.7895 161.901 21.1735 176 14.5C182.301 12.9699 188.09 11.6946 193.5 10.7176M219.5 8.57949L217 1C217.795 5.36797 217.934 7.44385 216 8.48299M219.5 8.57949C218.343 8.52259 217.178 8.49067 216 8.48299M216 8.48299C214.036 8.47017 212.04 8.52474 210 8.64325M198 1C203.775 2.70232 206.473 4.29207 210 8.64325M210 8.64325C207.567 8.78459 205.073 9.01687 202.5 9.33421M193.5 6.5C197.663 4.97435 199.8 4.91761 202.5 9.33421M202.5 9.33421C199.609 9.69075 196.617 10.1547 193.5 10.7176M193.5 10.7176C190.7 8.92493 188.662 8.49975 182 11.5M248 42.5C258 65 284.397 47.3259 277.5 100.5M245 35.5C243.18 48.2426 232.753 52.7929 219.5 55.4484M153.5 120C145.165 66.7175 177.058 61.8139 205.5 57.7084M224 30C228.5 38.5 232.296 50.9126 205.5 57.7084M205.5 57.7084C210.338 57.01 215.076 56.3348 219.5 55.4484M210 73.5C205.5 68 205.149 60.7915 219.5 55.4484M176 104C179.5 104 186.5 99 194.5 102M230 100.5C240 100.5 245 100.5 248 106M204 139.5C206.827 139.187 207.715 139.72 207.5 142.5M215.5 142.5C215.483 140.49 215.784 139.582 218.5 139.5M195.5 154.5C196.831 156.25 196.988 157.602 196.5 160.5C199.846 157.189 202.014 155.631 207 154C208.232 155.832 209.002 156.364 210.5 156.5C212.641 156.446 213.42 155.886 214.5 154.5C219.001 155.246 221.333 156.054 225 158.5C225.522 157.516 225.567 156.875 225 155.5M205 165C212.461 165.775 217.165 166.715 220 163M189 113.5C193.267 114.215 194.555 115.363 194.5 119C193.676 121.988 192.459 123.071 189 124C186.088 123.822 184.576 123.498 184 119C184.064 115.249 185.374 114.227 189 113.5ZM235 113.5C231.5 113.5 229 115 229 119C229 123 231 124 234 124C237 124 239 123 239.5 119C239.5 117 239.258 113.526 235 113.5Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_right_lower_arm)"
        @mouseover="activeArea = areas.front_right_lower_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        stroke="black"
        :fill="
          data.front_right_lower_arm.selected
            ? areas.front_right_lower_arm.activeColor
            : areas.front_right_lower_arm.inactiveColor
        "
        :class="{ active: data.front_right_lower_arm.selected, hovered: activeArea == areas.front_right_lower_arm }"
        class="ax-selectable"
        d="M382 407.5C368.5 385.5 372.5 366 362.5 339.5L318 358.5C326.5 385 339.5 391.5 350 424.5L382 407.5Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_left_upper_arm)"
        @mouseover="activeArea = areas.front_left_upper_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        stroke="black"
        :fill="
          data.front_left_upper_arm.selected
            ? areas.front_left_upper_arm.activeColor
            : areas.front_left_upper_arm.inactiveColor
        "
        :class="{ active: data.front_left_upper_arm.selected, hovered: activeArea == areas.front_left_upper_arm }"
        class="ax-selectable"
        d="M80.7651 273C86.2651 241.5 92.6246 214.922 129 208C130.235 245 129 268.5 133 283C133 284.5 131.765 286.5 131.265 287L80.7651 273Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_left_middle_arm)"
        @mouseover="activeArea = areas.front_left_middle_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        stroke="black"
        :fill="
          data.front_left_middle_arm.selected
            ? areas.front_left_middle_arm.activeColor
            : areas.front_left_middle_arm.inactiveColor
        "
        :class="{ active: data.front_left_middle_arm.selected, hovered: activeArea == areas.front_left_middle_arm }"
        class="ax-selectable"
        d="M74.7651 314C73.8446 300.486 75.274 291.421 80.7651 273L131.265 287C125.794 308.998 120.474 317.053 110.765 331C110.562 345.224 109.373 351.685 104.265 359L59.7651 340C63.7713 328.349 66.5292 322.231 74.7651 314Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_left_middle_arm)"
        @mouseover="activeArea = areas.front_left_middle_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :class="{ active: data.front_left_middle_arm.selected, hovered: activeArea == areas.front_left_middle_arm }"
        class="ax-selectable"
        d="M74.7651 314C73.8446 300.486 75.274 291.421 80.7651 273L131.265 287C125.794 308.998 120.474 317.053 110.765 331M74.7651 314C66.5292 322.231 63.7713 328.349 59.7651 340L104.265 359C109.373 351.685 110.562 345.224 110.765 331M74.7651 314C76.1003 312.2 77.0502 311.304 79.2651 310M110.765 331C108.49 332.539 107.361 333.678 105.765 336.5"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_upper_chest)"
        @mouseover="activeArea = areas.front_upper_chest"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        stroke="black"
        :fill="
          data.front_upper_chest.selected ? areas.front_upper_chest.activeColor : areas.front_upper_chest.inactiveColor
        "
        :class="{ active: data.front_upper_chest.selected, hovered: activeArea == areas.front_upper_chest }"
        d="M129 208C161.331 201.53 175.487 196.545 172.5 178C182.035 180.875 187.143 182.652 196 186C208.303 194.115 215.442 193.637 228.5 186C235.625 181.409 240.645 179.74 251 178C247.252 202.08 269 200.5 293.5 208V249C230.774 254.74 194.742 254.689 129 249V208Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_right_upper_arm)"
        @mouseover="activeArea = areas.front_right_upper_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        stroke="black"
        :fill="
          data.front_right_upper_arm.selected
            ? areas.front_right_upper_arm.activeColor
            : areas.front_right_upper_arm.inactiveColor
        "
        :class="{ active: data.front_right_upper_arm.selected, hovered: activeArea == areas.front_right_upper_arm }"
        class="ax-selectable"
        d="M341.5 272.5C336 241 329.875 214.922 293.5 208C292 246 296.5 269.5 290 283.5C290 285 290.5 286 291 286.5L341.5 272.5Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_right_middle_arm)"
        @mouseover="activeArea = areas.front_right_middle_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        stroke="black"
        :fill="
          data.front_right_middle_arm.selected
            ? areas.front_right_middle_arm.activeColor
            : areas.front_right_middle_arm.inactiveColor
        "
        :class="{ active: data.front_right_middle_arm.selected, hovered: activeArea == areas.front_right_middle_arm }"
        class="ax-selectable"
        d="M347.5 313.5C348.42 299.986 346.991 290.921 341.5 272.5L291 286.5C296.471 308.498 301.791 316.553 311.5 330.5C311.703 344.724 312.892 351.185 318 358.5L362.5 339.5C358.494 327.849 355.736 321.731 347.5 313.5Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_right_middle_arm)"
        @mouseover="activeArea = areas.front_right_middle_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :class="{ active: data.front_right_middle_arm.selected, hovered: activeArea == areas.front_right_middle_arm }"
        class="ax-selectable"
        d="M347.5 313.5C348.42 299.986 346.991 290.921 341.5 272.5L291 286.5C296.471 308.498 301.791 316.553 311.5 330.5M347.5 313.5C355.736 321.731 358.494 327.849 362.5 339.5L318 358.5C312.892 351.185 311.703 344.724 311.5 330.5M347.5 313.5C346.165 311.7 345.215 310.804 343 309.5M311.5 330.5C313.775 332.039 314.904 333.178 316.5 336"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_lower_chest)"
        @mouseover="activeArea = areas.front_lower_chest"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        stroke="black"
        :fill="
          data.front_lower_chest.selected ? areas.front_lower_chest.activeColor : areas.front_lower_chest.inactiveColor
        "
        :class="{ active: data.front_lower_chest.selected, hovered: activeArea == areas.front_lower_chest }"
        d="M236.5 466C268.446 457.431 280.891 446.878 294 418.5C295.546 410.253 294.037 398.951 292.212 385.278L292.108 384.5C290.416 371.822 288.5 357.144 288.5 341C259 391 167.5 392.5 134 341C133.527 364.645 131.489 378.002 129.842 388C128.005 399.144 126.655 406.113 128.5 418.5C143.841 450.076 157.539 458.933 187 466C192.5 455.5 198.5 449.5 213 449.5C227 449.5 231.5 456 236.5 466Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_lower_chest)"
        @mouseover="activeArea = areas.front_lower_chest"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M129.842 388C128.005 399.144 126.655 406.113 128.5 418.5C143.841 450.076 157.539 458.933 187 466C192.5 455.5 198.5 449.5 213 449.5C227 449.5 231.5 456 236.5 466C268.446 457.431 280.891 446.878 294 418.5C295.576 410.097 293.979 398.522 292.108 384.5M129.842 388C131.489 378.002 133.527 364.645 134 341C167.5 392.5 259 391 288.5 341C288.5 357.144 290.416 371.822 292.108 384.5M129.842 388C131.228 400 136.8 425.8 148 433M292.108 384.5C292.405 394.5 289.6 418.3 276 433.5M214 405.5C210.256 409.058 209.462 406.424 209 405.5C208.5 404.5 208 401.359 211.5 401.5C215 401.641 208.587 405.5 214 405.5ZM214 405.5C215.167 403.167 216.5 398.6 212.5 399"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_middle_left_leg)"
        @mouseover="activeArea = areas.front_middle_left_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        stroke="black"
        :fill="
          data.front_middle_left_leg.selected
            ? areas.front_middle_left_leg.activeColor
            : areas.front_middle_left_leg.inactiveColor
        "
        :class="{ active: data.front_middle_left_leg.selected, hovered: activeArea == areas.front_middle_left_leg }"
        d="M206.765 576C211.165 572 211.599 552 211.265 542.5H128.765C132.664 571.874 137.064 587.184 148.765 612.5C147.782 620.115 147.734 624.385 148.765 632C149.599 636.5 152.265 647 156.265 653C153.465 657.4 151.765 674.833 151.265 683H211.265V662C211.265 660 208.932 655.167 207.765 653C213.765 639.5 209.765 616 211.265 598.5C210.265 592.833 207.965 580.4 206.765 576Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_middle_left_leg)"
        @mouseover="activeArea = areas.front_middle_left_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M206.765 576C211.165 572 211.599 552 211.265 542.5H128.765C132.664 571.874 137.064 587.184 148.765 612.5M206.765 576C207.965 580.4 210.265 592.833 211.265 598.5C209.765 616 213.765 639.5 207.765 653C208.932 655.167 211.265 660 211.265 662C211.265 664 211.265 676.833 211.265 683H151.265C151.765 674.833 153.465 657.4 156.265 653M206.765 576C205.932 572.667 203.365 565.5 199.765 563.5M156.265 653C152.265 647 149.599 636.5 148.765 632C147.734 624.385 147.782 620.115 148.765 612.5M156.265 653C157.265 654.333 159.465 657 160.265 657M148.765 612.5C150.765 610.9 150.932 603.5 150.765 600M172.265 645C170.099 643.833 165.465 640.4 164.265 636"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_lower_left_leg)"
        @mouseover="activeArea = areas.front_lower_left_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        stroke="black"
        :fill="
          data.front_lower_left_leg.selected
            ? areas.front_lower_left_leg.activeColor
            : areas.front_lower_left_leg.inactiveColor
        "
        :class="{ active: data.front_lower_left_leg.selected, hovered: activeArea == areas.front_lower_left_leg }"
        d="M161.265 739.5C157.116 724.741 154.858 714.391 151.265 683L211.265 682.827V713.5C211.56 725.739 210.735 731.126 207.765 738.5C209.966 746.481 209.48 750.584 206.765 757.5C210.339 761.17 210.97 763.995 211.265 769.5V783.5C204.997 785.556 200.606 785.802 193.265 784.293C192.17 784.068 191.008 783.803 189.765 783.5C185.621 785.573 182.018 785.188 174.765 783.5C170.274 784.794 167.756 784.88 163.265 783.5C158.014 784.529 155.178 784.468 150.265 783.5C146.219 783.05 144.759 781.916 145.265 776.5C150.386 768.164 154.361 763.458 163.265 755C158.247 750.084 157.723 746.709 161.265 739.5Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_lower_left_leg)"
        @mouseover="activeArea = areas.front_lower_left_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M163.265 755C158.247 750.084 157.723 746.709 161.265 739.5C157.116 724.741 154.858 714.391 151.265 683L211.265 682.827V713.5C211.56 725.739 210.735 731.126 207.765 738.5C209.966 746.481 209.48 750.584 206.765 757.5M163.265 755C154.361 763.458 150.386 768.164 145.265 776.5C144.759 781.916 146.219 783.05 150.265 783.5C155.178 784.468 158.014 784.529 163.265 783.5M163.265 755C166.065 749 177.765 747.167 183.265 747M163.265 783.5C167.756 784.88 170.274 784.794 174.765 783.5M163.265 783.5C161.665 781.1 163.932 776.5 165.265 774.5M174.765 783.5C182.018 785.188 185.621 785.573 189.765 783.5C191.008 783.803 192.17 784.068 193.265 784.293M174.765 783.5C173.965 778.3 176.432 774.667 177.765 773.5M206.765 757.5C210.339 761.17 210.97 763.995 211.265 769.5V783.5C204.997 785.556 200.606 785.802 193.265 784.293M206.765 757.5C205.932 756 203.865 753 202.265 753M205.265 769.5H196.765M185.265 771H181.265M172.765 772.5H168.765M159.765 773.5H158.265M154.765 774.5C153.765 776.167 151.965 779.9 152.765 781.5M193.265 784.293C190.932 781.862 187.165 775.8 190.765 771"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_lower_right_leg)"
        @mouseover="activeArea = areas.front_lower_right_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        stroke="black"
        :fill="
          data.front_lower_right_leg.selected
            ? areas.front_lower_right_leg.activeColor
            : areas.front_lower_right_leg.inactiveColor
        "
        :class="{ active: data.front_lower_right_leg.selected, hovered: activeArea == areas.front_lower_right_leg }"
        d="M262 739.5C266.15 724.741 268.407 714.391 272 683L212 682.827V713.5C211.705 725.739 212.53 731.126 215.5 738.5C213.3 746.481 213.786 750.584 216.5 757.5C212.927 761.17 212.295 763.995 212 769.5V783.5C218.268 785.556 222.659 785.802 230 784.293C231.096 784.068 232.257 783.803 233.5 783.5C237.644 785.573 241.247 785.188 248.5 783.5C252.991 784.794 255.509 784.88 260 783.5C265.251 784.529 268.088 784.468 273 783.5C277.046 783.05 278.507 781.916 278 776.5C272.879 768.164 268.904 763.458 260 755C265.019 750.084 265.542 746.709 262 739.5Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_lower_right_leg)"
        @mouseover="activeArea = areas.front_lower_right_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M260 755C265.019 750.084 265.542 746.709 262 739.5C266.15 724.741 268.407 714.391 272 683L212 682.827V713.5C211.705 725.739 212.53 731.126 215.5 738.5C213.3 746.481 213.786 750.584 216.5 757.5M260 755C268.904 763.458 272.879 768.164 278 776.5C278.507 781.916 277.046 783.05 273 783.5C268.088 784.468 265.251 784.529 260 783.5M260 755C257.2 749 245.5 747.167 240 747M260 783.5C255.509 784.88 252.991 784.794 248.5 783.5M260 783.5C261.6 781.1 259.333 776.5 258 774.5M248.5 783.5C241.247 785.188 237.644 785.573 233.5 783.5C232.257 783.803 231.096 784.068 230 784.293M248.5 783.5C249.3 778.3 246.833 774.667 245.5 773.5M216.5 757.5C212.927 761.17 212.295 763.995 212 769.5V783.5C218.268 785.556 222.659 785.802 230 784.293M216.5 757.5C217.333 756 219.4 753 221 753M218 769.5H226.5M238 771H242M250.5 772.5H254.5M263.5 773.5H265M268.5 774.5C269.5 776.167 271.3 779.9 270.5 781.5M230 784.293C232.333 781.862 236.1 775.8 232.5 771"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_middle_right_leg)"
        @mouseover="activeArea = areas.front_middle_right_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        stroke="black"
        :fill="
          data.front_middle_right_leg.selected
            ? areas.front_middle_right_leg.activeColor
            : areas.front_middle_right_leg.inactiveColor
        "
        :class="{ active: data.front_middle_right_leg.selected, hovered: activeArea == areas.front_middle_right_leg }"
        d="M216.5 576C212.1 572 211.667 552 212 542.5H294.5C290.601 571.874 286.201 587.184 274.5 612.5C275.483 620.115 275.531 624.385 274.5 632C273.667 636.5 271 647 267 653C269.8 657.4 271.5 674.833 272 683H212V662C212 660 214.333 655.167 215.5 653C209.5 639.5 213.5 616 212 598.5C213 592.833 215.3 580.4 216.5 576Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_middle_right_leg)"
        @mouseover="activeArea = areas.front_middle_right_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M216.5 576C212.1 572 211.667 552 212 542.5H294.5C290.601 571.874 286.201 587.184 274.5 612.5M216.5 576C215.3 580.4 213 592.833 212 598.5C213.5 616 209.5 639.5 215.5 653C214.333 655.167 212 660 212 662C212 664 212 676.833 212 683H272C271.5 674.833 269.8 657.4 267 653M216.5 576C217.333 572.667 219.9 565.5 223.5 563.5M267 653C271 647 273.667 636.5 274.5 632C275.531 624.385 275.483 620.115 274.5 612.5M267 653C266 654.333 263.8 657 263 657M274.5 612.5C272.5 610.9 272.333 603.5 272.5 600M251 645C253.167 643.833 257.8 640.4 259 636"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_left_lower_arm)"
        @mouseover="activeArea = areas.front_left_lower_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        stroke="black"
        :fill="
          data.front_left_lower_arm.selected
            ? areas.front_left_lower_arm.activeColor
            : areas.front_left_lower_arm.inactiveColor
        "
        :class="{ active: data.front_left_lower_arm.selected, hovered: activeArea == areas.front_left_lower_arm }"
        d="M40.2651 408C53.7651 386 49.7651 366.5 59.7651 340L104.265 359C95.7651 385.5 82.7651 392 72.2651 425L40.2651 408Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_left_hand)"
        @mouseover="activeArea = areas.front_left_hand"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        stroke="black"
        :fill="data.front_left_hand.selected ? areas.front_left_hand.activeColor : areas.front_left_hand.inactiveColor"
        :class="{ active: data.front_left_hand.selected, hovered: activeArea == areas.front_left_hand }"
        d="M15.7652 427C26.2652 418 34.7652 418.5 40.2652 408L72.2652 425C74.4893 433.049 74.3603 437.822 73.2652 446.5C65.4425 461.308 60.0617 468.502 49.2652 480C44.8785 481.951 43.1106 481.902 42.2652 478C41.7652 480.5 38.2651 482.2 36.2652 482.5C32.0093 483.138 32.1332 481.776 31.2652 480C28.8078 483.01 27.794 483.935 26.2652 485C21.7652 486 19.5219 485.357 19.2652 478C14.7217 475.86 12.724 474.32 15.7652 467.5C18.308 458.975 20.343 453.94 26.2652 444C27.6136 441.07 27.811 439.142 27.7652 435.5C23.7652 434 21.2652 440 11.7652 446.5C2.76518 449.5 0.0764236 446.501 1.26517 441C7.4819 438.153 10.5445 434.558 15.7652 427Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_left_hand)"
        @mouseover="activeArea = areas.front_left_hand"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M27.7652 435.5C23.7652 434 21.2652 440 11.7652 446.5C2.76519 449.5 0.0764246 446.501 1.26517 441C7.4819 438.153 10.5445 434.558 15.7652 427C26.2652 418 34.7652 418.5 40.2652 408L72.2652 425C74.4893 433.049 74.3603 437.822 73.2652 446.5C65.4425 461.308 60.0617 468.502 49.2652 480C44.8785 481.951 43.1106 481.902 42.2652 478M27.7652 435.5C27.811 439.142 27.6136 441.07 26.2652 444C20.343 453.94 18.308 458.975 15.7652 467.5C12.724 474.32 14.7217 475.86 19.2652 478M27.7652 435.5C27.3652 432.7 35.9319 432.333 40.2652 432.5M19.2652 478C19.5219 485.357 21.7652 486 26.2652 485C27.794 483.935 28.8078 483.01 31.2652 480M19.2652 478L33.2652 453M31.2652 480C32.1332 481.776 32.0093 483.138 36.2652 482.5C38.2651 482.2 41.7652 480.5 42.2652 478M31.2652 480C31.2652 477.6 38.5985 464.667 42.2652 458.5M42.2652 478C41.4652 475.2 49.5985 464.167 53.7652 459M47.2652 457C43.2652 457 34.8652 455.6 33.2652 450M48.2652 427C46.4318 429 42.2652 432.9 40.2652 432.5M40.2652 432.5C41.4652 438.5 49.7652 437.667 53.7652 436.5"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_right_hand)"
        @mouseover="activeArea = areas.front_right_hand"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.front_right_hand.selected ? areas.front_right_hand.activeColor : areas.front_right_hand.inactiveColor
        "
        :class="{ active: data.front_right_hand.selected, hovered: activeArea == areas.front_right_hand }"
        d="M406.5 426.5C396 417.5 387.5 418 382 407.5L350 424.5C347.776 432.549 347.905 437.322 349 446C356.823 460.808 362.203 468.002 373 479.5C377.387 481.451 379.155 481.402 380 477.5C380.5 480 384 481.7 386 482C390.256 482.638 390.132 481.276 391 479.5C393.457 482.51 394.471 483.435 396 484.5C400.5 485.5 402.743 484.857 403 477.5C407.544 475.36 409.541 473.82 406.5 467C403.957 458.475 401.922 453.44 396 443.5C394.652 440.57 394.454 438.642 394.5 435C398.5 433.5 401 439.5 410.5 446C419.5 449 422.189 446.001 421 440.5C414.783 437.653 411.721 434.058 406.5 426.5Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_right_hand)"
        @mouseover="activeArea = areas.front_right_hand"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M394.5 435C398.5 433.5 401 439.5 410.5 446C419.5 449 422.189 446.001 421 440.5C414.783 437.653 411.721 434.058 406.5 426.5C396 417.5 387.5 418 382 407.5L350 424.5C347.776 432.549 347.905 437.322 349 446C356.823 460.808 362.203 468.002 373 479.5C377.387 481.451 379.155 481.402 380 477.5M394.5 435C394.454 438.642 394.652 440.57 396 443.5C401.922 453.44 403.957 458.475 406.5 467C409.541 473.82 407.544 475.36 403 477.5M394.5 435C394.9 432.2 386.333 431.833 382 432M403 477.5C402.743 484.857 400.5 485.5 396 484.5C394.471 483.435 393.457 482.51 391 479.5M403 477.5L389 452.5M391 479.5C390.132 481.276 390.256 482.638 386 482C384 481.7 380.5 480 380 477.5M391 479.5C391 477.1 383.667 464.167 380 458M380 477.5C380.8 474.7 372.667 463.667 368.5 458.5M375 456.5C379 456.5 387.4 455.1 389 449.5M374 426.5C375.833 428.5 380 432.4 382 432M382 432C380.8 438 372.5 437.167 368.5 436"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_middle_chest)"
        @mouseover="activeArea = areas.front_middle_chest"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :class="{ active: data.front_middle_chest.selected, hovered: activeArea == areas.front_middle_chest }"
        class="ax-selectable"
        :fill="
          data.front_middle_chest.selected
            ? areas.front_middle_chest.activeColor
            : areas.front_middle_chest.inactiveColor
        "
        d="M134 287C130.32 274.324 129.418 265.63 129 248.5C192.853 255.009 228.806 255.202 293.5 249.5C293.646 266.344 293.477 275.525 288.5 287C286.953 311.036 285.984 324.708 288.5 341C260 391 165.5 391.5 134 341C135.513 319.285 134.88 307.724 134 287Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_middle_chest)"
        @mouseover="activeArea = areas.front_middle_chest"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        :class="{ active: data.front_middle_chest.selected, hovered: activeArea == areas.front_middle_chest }"
        class="ax-selectable"
        d="M134 287C130.32 274.324 129.418 265.63 129 248.5C192.853 255.009 228.806 255.202 293.5 249.5C293.646 266.344 293.477 275.525 288.5 287M134 287C134.88 307.724 135.513 319.285 134 341C165.5 391.5 260 391 288.5 341C285.984 324.708 286.953 311.036 288.5 287M134 287C140.304 296.256 145.745 298.986 156.5 302.5M288.5 287C281.093 296.435 275.536 299.31 264.5 302.5M255.5 281L256.5 282M167.5 282L169 280.5M167 281.5L168.5 280M168 282.5L169.5 281M257 281.5L256 280.5M257.5 281L256.5 280"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.genitalia)"
        @mouseover="activeArea = areas.genitalia"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        stroke="black"
        :fill="data.genitalia.selected ? areas.genitalia.activeColor : areas.genitalia.inactiveColor"
        :class="{ active: data.genitalia.selected, hovered: activeArea == areas.genitalia }"
        d="M238.003 477.449L238 477.474V477.5C238 491.701 225.883 503 211.5 503C197.149 503 185.5 491.144 185.5 476.5C185.5 461.856 197.149 450 211.5 450H211.531L211.562 449.996C219.375 449.02 226.346 452.311 231.192 457.649C236.044 462.992 238.737 470.354 238.003 477.449Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_upper_right_leg)"
        @mouseover="activeArea = areas.front_upper_right_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        stroke="black"
        :fill="
          data.front_upper_right_leg.selected
            ? areas.front_upper_right_leg.activeColor
            : areas.front_upper_right_leg.inactiveColor
        "
        :class="{ active: data.front_upper_right_leg.selected, hovered: activeArea == areas.front_upper_right_leg }"
        d="M294.5 450.5C295.362 437.084 295.491 429.458 294.5 415.5L294 419C279.634 447.901 267.056 458.202 236.5 466C238.8 474.785 238.728 479.481 236.5 487.5C231.28 495.713 227.571 499.126 219.5 503C213.202 516.801 215 526.5 212 542.5H294.5C307.092 504.491 307.942 484.208 294.5 450.5Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_upper_right_leg)"
        @mouseover="activeArea = areas.front_upper_right_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :class="{ active: data.front_upper_right_leg.selected, hovered: activeArea == areas.front_upper_right_leg }"
        d="M236.5 487.5C231.28 495.713 227.571 499.126 219.5 503C213.202 516.801 215 526.5 212 542.5H294.5C307.092 504.491 307.942 484.208 294.5 450.5C295.362 437.084 295.491 429.458 294.5 415.5L294 419C279.634 447.901 267.056 458.202 236.5 466C238.8 474.786 238.728 479.481 236.5 487.5ZM236.5 487.5C238.333 486.167 242.1 483.3 242.5 482.5"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_upper_left_leg)"
        @mouseover="activeArea = areas.front_upper_left_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        stroke="black"
        :fill="
          data.front_upper_left_leg.selected
            ? areas.front_upper_left_leg.activeColor
            : areas.front_upper_left_leg.inactiveColor
        "
        :class="{ active: data.front_upper_left_leg.selected, hovered: activeArea == areas.front_upper_left_leg }"
        d="M128.765 450.5C127.903 437.084 127.774 429.458 128.765 415.5L129.265 419C143.631 447.901 156.209 458.202 186.765 466C184.465 474.785 184.537 479.481 186.765 487.5C191.985 495.713 195.695 499.126 203.765 503C210.063 516.801 208.265 526.5 211.265 542.5H128.765C116.173 504.491 115.323 484.208 128.765 450.5Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.front_upper_left_leg)"
        @mouseover="activeArea = areas.front_upper_left_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :class="{ active: data.front_upper_left_leg.selected, hovered: activeArea == areas.front_upper_left_leg }"
        d="M186.765 487.5C191.985 495.713 195.695 499.126 203.765 503C210.063 516.801 208.265 526.5 211.265 542.5H128.765C116.173 504.491 115.323 484.208 128.765 450.5C127.903 437.084 127.774 429.458 128.765 415.5L129.265 419C143.631 447.901 156.209 458.202 186.765 466C184.465 474.786 184.537 479.481 186.765 487.5ZM186.765 487.5C184.932 486.167 181.165 483.3 180.765 482.5"
        stroke="black"
      />
    </svg>
    <svg
      :height="height"
      :width="width"
      fill="none"
      viewBox="0 0 422 786"
      xmlns="http://www.w3.org/2000/svg"
      :style="[{ 'pointer-events': readOnly ? 'none' : 'fill' }]"
    >
      <path
        @click="eventClickOnGerericAreas(areas.back_right_lower_arm)"
        @mouseover="activeArea = areas.back_right_lower_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.back_right_lower_arm.selected
            ? areas.back_right_lower_arm.activeColor
            : areas.back_right_lower_arm.inactiveColor
        "
        :class="{ active: data.back_right_lower_arm.selected, hovered: activeArea == areas.back_right_lower_arm }"
        d="M382 401.5C368.5 379.5 372.5 360 362.5 333.5L318 352.5C326.5 379 339.5 385.5 350 418.5L382 401.5Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_left_upper_arm)"
        @mouseover="activeArea = areas.back_left_upper_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.back_left_upper_arm.selected
            ? areas.back_left_upper_arm.activeColor
            : areas.back_left_upper_arm.inactiveColor
        "
        :class="{ active: data.back_left_upper_arm.selected, hovered: activeArea == areas.back_left_upper_arm }"
        d="M80.7651 267C86.2651 235.5 92.6246 208.922 129 202C130.235 239 129 262.5 133 277C133 278.5 131.765 280.5 131.265 281L80.7651 267Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_left_middle_arm)"
        @mouseover="activeArea = areas.back_left_middle_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.back_left_middle_arm.selected
            ? areas.back_left_middle_arm.activeColor
            : areas.back_left_middle_arm.inactiveColor
        "
        :class="{ active: data.back_left_middle_arm.selected, hovered: activeArea == areas.back_left_middle_arm }"
        d="M74.7651 308C73.8446 294.486 75.274 285.421 80.7651 267L131.265 281C125.794 302.998 120.474 311.053 110.765 325C110.562 339.224 109.373 345.685 104.265 353L59.7651 334C63.7713 322.349 66.5292 316.231 74.7651 308Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_left_middle_arm)"
        @mouseover="activeArea = areas.back_left_middle_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :class="{ active: data.back_left_middle_arm.selected, hovered: activeArea == areas.back_left_middle_arm }"
        d="M74.7651 308C73.8446 294.486 75.274 285.421 80.7651 267L131.265 281C125.794 302.998 120.474 311.053 110.765 325M74.7651 308C66.5292 316.231 63.7713 322.349 59.7651 334L104.265 353C109.373 345.685 110.562 339.224 110.765 325M74.7651 308C76.1003 306.2 77.0502 305.304 79.2651 304M110.765 325C108.49 326.539 107.361 327.678 105.765 330.5M80.7651 321.5C83.7694 326.471 86.0603 327.057 91 325"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.head)"
        @mouseover="activeArea = areas.head"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="data.head.selected ? areas.head.activeColor : areas.head.inactiveColor"
        :class="{ active: data.head.selected, hovered: activeArea == areas.head }"
        d="M136 76.1763C139.883 37.6431 160.267 13.5599 201.036 10.1883H203.463C204.052 6.16417 204.731 4.10062 208.801 2C206.946 5.10209 205.971 6.8461 207.345 10.1883H212.199H218.993H231.127C271.896 16.9316 285 46.7948 285 76.1763C285 126.5 261.5 162.5 214.5 163.5C177.865 166.891 145.201 133.735 136 76.1763Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.head)"
        @mouseover="activeArea = areas.head"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M203.463 10.1883H201.036C160.267 13.5599 139.883 37.6431 136 76.1763C145.201 133.735 177.865 166.891 214.5 163.5C261.5 162.5 285 126.5 285 76.1763C285 46.7948 271.896 16.9316 231.127 10.1883H218.993M203.463 10.1883C204.052 6.16417 204.731 4.10062 208.801 2C206.946 5.10209 205.971 6.8461 207.345 10.1883M203.463 10.1883H207.345M207.345 10.1883H212.199M212.199 10.1883C216.182 5.44572 218.852 3.38106 225.303 2M212.199 10.1883H218.993M218.993 10.1883C222.607 7.45303 224.678 6.32887 228.7 7.29831"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_upper_chest)"
        @mouseover="activeArea = areas.back_upper_chest"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.back_upper_chest.selected ? areas.back_upper_chest.activeColor : areas.back_upper_chest.inactiveColor
        "
        :class="{ active: data.back_upper_chest.selected, hovered: activeArea == areas.back_upper_chest }"
        d="M133.839 116.145C132.892 108.882 136.534 106.522 145.935 108.882C152.292 128.744 163.727 143.141 177.387 152.186C195.365 164.09 217.196 166.723 236.375 160.34C237.985 159.667 239.767 158.988 241.742 158.287C259.979 150.366 275.082 133.818 280.935 108.882C287.004 107.4 288.333 109.184 287.71 116.145C286.742 126.957 276.097 134.544 272.71 149.553C270.225 151.513 269.009 151.757 267.387 149.553C264.223 162.217 260.365 167.351 248.516 171.826C247.014 179.403 247.279 183.388 250.935 189.74C270.039 193.761 278.706 195.935 293.5 202V243.5C229.114 250.891 193.31 250.736 130 242.5L129 202C144.112 195.121 153.062 193.235 169.354 189.802L169.645 189.74C174.818 185.568 175.236 181.314 173.516 171.826C163.019 167.525 158.964 162.934 156.097 149.553C153.831 150.918 152.421 151.184 149.323 149.553C145.935 134.544 135.29 127.281 133.839 116.145Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_upper_chest)"
        @mouseover="activeArea = areas.back_upper_chest"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M156.097 149.553C153.831 150.918 152.421 151.184 149.323 149.553C145.935 134.544 135.29 127.281 133.839 116.145C132.892 108.882 136.534 106.522 145.935 108.882C152.292 128.744 163.727 143.141 177.387 152.186M156.097 149.553C158.964 162.934 163.019 167.525 173.516 171.826M156.097 149.553C156.097 144.518 153.194 138.094 151.742 135.512M173.516 171.826C175.236 181.314 174.818 185.568 169.645 189.74C153.168 193.213 144.201 195.08 129 202L130 242.5C193.31 250.736 229.114 250.891 293.5 243.5V202C278.706 195.935 270.039 193.761 250.935 189.74C247.279 183.388 247.014 179.403 248.516 171.826M173.516 171.826C173.677 169.082 173.71 163.207 172.548 161.658M248.516 171.826C260.365 167.351 264.223 162.217 267.387 149.553M248.516 171.826C246.581 164.466 249.323 161.658 250.935 161.174M267.387 149.553C269.009 151.757 270.225 151.513 272.71 149.553C276.097 134.544 286.742 126.957 287.71 116.145C288.333 109.184 287.004 107.4 280.935 108.882C275.082 133.818 259.979 150.366 241.742 158.287M267.387 149.553V143.259M177.387 152.186C185.613 162.142 215.032 170.954 216.581 181.025M177.387 152.186C197.066 165.216 221.361 167.138 241.742 158.287M221.419 175.699C223.423 167.099 227.762 163.252 241.742 158.287"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_right_upper_arm)"
        @mouseover="activeArea = areas.back_right_upper_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.back_right_upper_arm.selected
            ? areas.back_right_upper_arm.activeColor
            : areas.back_right_upper_arm.inactiveColor
        "
        :class="{ active: data.back_right_upper_arm.selected, hovered: activeArea == areas.back_right_upper_arm }"
        d="M341.5 266.5C336 235 329.875 208.922 293.5 202C292 240 296.5 263.5 290 277.5C290 279 290.5 280 291 280.5L341.5 266.5Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_right_middle_arm)"
        @mouseover="activeArea = areas.back_right_middle_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.back_right_middle_arm.selected
            ? areas.back_right_middle_arm.activeColor
            : areas.back_right_middle_arm.inactiveColor
        "
        :class="{ active: data.back_right_middle_arm.selected, hovered: activeArea == areas.back_right_middle_arm }"
        d="M347.5 307.5C348.42 293.986 346.991 284.921 341.5 266.5L291 280.5C296.471 302.498 301.791 310.553 311.5 324.5C311.703 338.724 312.892 345.185 318 352.5L362.5 333.5C358.494 321.849 355.736 315.731 347.5 307.5Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_right_middle_arm)"
        @mouseover="activeArea = areas.back_right_middle_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :class="{ active: data.back_right_middle_arm.selected, hovered: activeArea == areas.back_right_middle_arm }"
        d="M347.5 307.5C348.42 293.986 346.991 284.921 341.5 266.5L291 280.5C296.471 302.498 301.791 310.553 311.5 324.5M347.5 307.5C355.736 315.731 358.494 321.849 362.5 333.5L318 352.5C312.892 345.185 311.703 338.724 311.5 324.5M347.5 307.5C346.165 305.7 345.215 304.804 343 303.5M311.5 324.5C313.775 326.039 314.904 327.178 316.5 330M327.5 333.5C334.812 331.537 338.189 329.829 341.5 324.5"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_lower_chest)"
        @mouseover="activeArea = areas.back_lower_chest"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.back_lower_chest.selected ? areas.back_lower_chest.activeColor : areas.back_lower_chest.inactiveColor
        "
        :class="{ active: data.back_lower_chest.selected, hovered: activeArea == areas.back_lower_chest }"
        d="M131 398C130.187 375.25 130.386 353.334 134 329.5C169.521 351.266 255.098 349.248 288.5 329.5C291.32 356.871 291.461 377.606 291.5 398C229.608 407.006 194.451 406.827 131 398Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_middle_left_leg)"
        @mouseover="activeArea = areas.back_middle_left_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.back_middle_left_leg.selected
            ? areas.back_middle_left_leg.activeColor
            : areas.back_middle_left_leg.inactiveColor
        "
        :class="{ active: data.back_middle_left_leg.selected, hovered: activeArea == areas.back_middle_left_leg }"
        d="M206.765 570C211.165 566 211.599 546 211.265 536.5H128.765C132.664 565.874 137.064 581.184 148.765 606.5C147.782 614.115 147.734 618.385 148.765 626C149.599 630.5 152.265 641 156.265 647C153.465 651.4 151.765 668.833 151.265 677H211.265V656C211.265 654 208.932 649.167 207.765 647C213.765 633.5 209.765 610 211.265 592.5C210.265 586.833 207.965 574.4 206.765 570Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_middle_left_leg)"
        @mouseover="activeArea = areas.back_middle_left_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M156.265 647C153.465 651.4 151.765 668.833 151.265 677H211.265C211.265 670.833 211.265 658 211.265 656C211.265 654 208.932 649.167 207.765 647C213.765 633.5 209.765 610 211.265 592.5C210.265 586.833 207.965 574.4 206.765 570C211.165 566 211.599 546 211.265 536.5H128.765C132.664 565.874 137.064 581.184 148.765 606.5C147.782 614.115 147.734 618.385 148.765 626C149.599 630.5 152.265 641 156.265 647ZM156.265 647C158.677 643.667 164.7 636.4 169.5 634"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_lower_left_leg)"
        @mouseover="activeArea = areas.back_lower_left_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.back_lower_left_leg.selected
            ? areas.back_lower_left_leg.activeColor
            : areas.back_lower_left_leg.inactiveColor
        "
        :class="{ active: data.back_lower_left_leg.selected, hovered: activeArea == areas.back_lower_left_leg }"
        d="M151.794 677.173C155.387 708.564 157.644 718.914 161.794 733.673C158.251 740.883 158.775 744.257 163.794 749.173C162.404 751.685 160.78 754.86 159.284 758.173C146.122 768.299 149.35 773.5 149.35 777.673H157.528H198.85C202.035 777.695 205.999 776.54 206.85 776C208.145 773.196 208.228 771.23 208.294 767.673C207.85 762.5 208.294 761.5 205.528 758.173C208.243 751.257 210.494 740.655 208.294 732.673C211.263 725.299 212.088 719.913 211.794 707.673V677L151.794 677.173Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_lower_left_leg)"
        @mouseover="activeArea = areas.back_lower_left_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M205.528 758.173C208.294 761.5 207.85 762.5 208.294 767.673C208.228 771.23 208.145 773.196 206.85 776C205.999 776.54 202.035 777.695 198.85 777.673M205.528 758.173C208.243 751.257 210.494 740.655 208.294 732.673C211.263 725.299 212.088 719.913 211.794 707.673V677L151.794 677.173C155.387 708.564 157.644 718.914 161.794 733.673C158.251 740.883 158.775 744.257 163.794 749.173C162.404 751.685 160.78 754.86 159.284 758.173M205.528 758.173C204.018 763.84 205.528 772.5 198.85 777.673M157.528 777.673C151.938 777.673 155.119 767.392 159.284 758.173M157.528 777.673H149.35C149.35 773.5 146.122 768.299 159.284 758.173M157.528 777.673C164.184 777.673 182.675 777.673 198.85 777.673"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_lower_right_leg)"
        @mouseover="activeArea = areas.back_lower_right_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.back_lower_right_leg.selected
            ? areas.back_lower_right_leg.activeColor
            : areas.back_lower_right_leg.inactiveColor
        "
        :class="{ active: data.back_lower_right_leg.selected, hovered: activeArea == areas.back_lower_right_leg }"
        d="M272.056 677.173C268.463 708.564 266.206 718.914 262.056 733.673C265.598 740.883 265.075 744.257 260.056 749.173C261.445 751.685 263.069 754.86 264.566 758.173C277.728 768.299 274.5 773.5 274.5 777.673H266.321H225C221.815 777.695 217.85 776.54 217 776C215.704 773.196 215.622 771.23 215.556 767.673C216 762.5 215.556 761.5 218.321 758.173C215.607 751.257 213.356 740.655 215.556 732.673C212.586 725.299 211.761 719.913 212.056 707.673V677L272.056 677.173Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_lower_right_leg)"
        @mouseover="activeArea = areas.back_lower_right_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M218.321 758.173C215.556 761.5 216 762.5 215.556 767.673C215.622 771.23 215.704 773.196 217 776C217.85 776.54 221.815 777.695 225 777.673M218.321 758.173C215.607 751.257 213.356 740.655 215.556 732.673C212.586 725.299 211.761 719.913 212.056 707.673V677L272.056 677.173C268.463 708.564 266.206 718.914 262.056 733.673C265.598 740.883 265.075 744.257 260.056 749.173C261.445 751.685 263.069 754.86 264.566 758.173M218.321 758.173C219.831 763.84 218.321 772.5 225 777.673M266.321 777.673C271.912 777.673 268.731 767.392 264.566 758.173M266.321 777.673H274.5C274.5 773.5 277.728 768.299 264.566 758.173M266.321 777.673C259.666 777.673 241.175 777.673 225 777.673"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_middle_right_leg)"
        @mouseover="activeArea = areas.back_middle_right_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.back_middle_right_leg.selected
            ? areas.back_middle_right_leg.activeColor
            : areas.back_middle_right_leg.inactiveColor
        "
        :class="{ active: data.back_middle_right_leg.selected, hovered: activeArea == areas.back_middle_right_leg }"
        d="M216.5 570C212.1 566 211.667 546 212 536.5H294.5C290.601 565.874 286.201 581.184 274.5 606.5C275.483 614.115 275.531 618.385 274.5 626C273.667 630.5 271 641 267 647C269.8 651.4 271.5 668.833 272 677H212V656C212 654 214.333 649.167 215.5 647C209.5 633.5 213.5 610 212 592.5C213 586.833 215.3 574.4 216.5 570Z"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_middle_right_leg)"
        @mouseover="activeArea = areas.back_middle_right_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        d="M216.5 570C212.1 566 211.667 546 212 536.5H294.5C290.601 565.874 286.201 581.184 274.5 606.5M216.5 570C215.3 574.4 213 586.833 212 592.5C213.5 610 209.5 633.5 215.5 647C214.333 649.167 212 654 212 656C212 658 212 670.833 212 677H272C271.5 668.833 269.8 651.4 267 647M216.5 570C217.333 566.667 219.9 559.5 223.5 557.5M267 647C271 641 273.667 630.5 274.5 626C275.531 618.385 275.483 614.115 274.5 606.5M267 647C264.667 643.667 258.6 636.9 253 636.5M274.5 606.5C272.5 604.9 272.333 597.5 272.5 594"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_left_lower_arm)"
        @mouseover="activeArea = areas.back_left_lower_arm"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.back_left_lower_arm.selected
            ? areas.back_left_lower_arm.activeColor
            : areas.back_left_lower_arm.inactiveColor
        "
        :class="{ active: data.back_left_lower_arm.selected, hovered: activeArea == areas.back_left_lower_arm }"
        d="M40.2651 402C53.7651 380 49.7651 360.5 59.7651 334L104.265 353C95.7651 379.5 82.7651 386 72.2651 419L40.2651 402Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_left_hand)"
        @mouseover="activeArea = areas.back_left_hand"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="data.back_left_hand.selected ? areas.back_left_hand.activeColor : areas.back_left_hand.inactiveColor"
        :class="{ active: data.back_left_hand.selected, hovered: activeArea == areas.back_left_hand }"
        d="M15.7652 421C26.2652 412 34.7652 412.5 40.2652 402L72.2652 419C74.4893 427.049 74.3603 431.822 73.2652 440.5C65.4425 455.308 60.0617 462.502 49.2652 474C44.8785 475.951 43.1106 475.902 42.2652 472C41.7652 474.5 38.2651 476.2 36.2652 476.5C32.0093 477.138 32.1332 475.776 31.2652 474C28.8078 477.01 27.794 477.935 26.2652 479C21.7652 480 19.5219 479.357 19.2652 472C14.7217 469.86 12.724 468.32 15.7652 461.5C18.308 452.975 20.343 447.94 26.2652 438C27.6136 435.07 27.811 433.142 27.7652 429.5C23.7652 428 21.2652 434 11.7652 440.5C2.76518 443.5 0.0764236 440.501 1.26517 435C7.4819 432.153 10.5445 428.558 15.7652 421Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_left_hand)"
        @mouseover="activeArea = areas.back_left_hand"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :class="{ active: data.back_left_hand.selected, hovered: activeArea == areas.back_left_hand }"
        d="M19.2652 472C14.7217 469.86 12.724 468.32 15.7652 461.5C18.308 452.975 20.343 447.94 26.2652 438C27.6136 435.07 27.811 433.142 27.7652 429.5C23.7652 428 21.2652 434 11.7652 440.5C2.76519 443.5 0.0764246 440.501 1.26517 435C7.4819 432.153 10.5445 428.558 15.7652 421C26.2652 412 34.7652 412.5 40.2652 402L72.2652 419C74.4893 427.049 74.3603 431.822 73.2652 440.5C65.4425 455.308 60.0617 462.502 49.2652 474C44.8785 475.951 43.1106 475.902 42.2652 472M19.2652 472C19.5219 479.357 21.7652 480 26.2652 479C27.794 477.935 28.8078 477.01 31.2652 474M19.2652 472L33.2652 447M31.2652 474C32.1332 475.776 32.0093 477.138 36.2652 476.5C38.2651 476.2 41.7652 474.5 42.2652 472M31.2652 474C31.2652 471.6 38.5985 458.667 42.2652 452.5M42.2652 472C41.4652 469.2 49.5985 458.167 53.7652 453"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_right_hand)"
        @mouseover="activeArea = areas.back_right_hand"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="data.back_right_hand.selected ? areas.back_right_hand.activeColor : areas.back_right_hand.inactiveColor"
        :class="{ active: data.back_right_hand.selected, hovered: activeArea == areas.back_right_hand }"
        d="M406.5 420.5C396 411.5 387.5 412 382 401.5L350 418.5C347.776 426.549 347.905 431.322 349 440C356.823 454.808 362.203 462.002 373 473.5C377.387 475.451 379.155 475.402 380 471.5C380.5 474 384 475.7 386 476C390.256 476.638 390.132 475.276 391 473.5C393.457 476.51 394.471 477.435 396 478.5C400.5 479.5 402.743 478.857 403 471.5C407.544 469.36 409.541 467.82 406.5 461C403.957 452.475 401.922 447.44 396 437.5C394.652 434.57 394.454 432.642 394.5 429C398.5 427.5 401 433.5 410.5 440C419.5 443 422.189 440.001 421 434.5C414.783 431.653 411.721 428.058 406.5 420.5Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_right_hand)"
        @mouseover="activeArea = areas.back_right_hand"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :class="{ active: data.back_right_hand.selected, hovered: activeArea == areas.back_right_hand }"
        d="M403 471.5C407.544 469.36 409.541 467.82 406.5 461C403.957 452.475 401.922 447.44 396 437.5C394.652 434.57 394.454 432.642 394.5 429C398.5 427.5 401 433.5 410.5 440C419.5 443 422.189 440.001 421 434.5C414.783 431.653 411.721 428.058 406.5 420.5C396 411.5 387.5 412 382 401.5L350 418.5C347.776 426.549 347.905 431.322 349 440C356.823 454.808 362.203 462.002 373 473.5C377.387 475.451 379.155 475.402 380 471.5M403 471.5C402.743 478.857 400.5 479.5 396 478.5C394.471 477.435 393.457 476.51 391 473.5M403 471.5L389 446.5M391 473.5C390.132 475.276 390.256 476.638 386 476C384 475.7 380.5 474 380 471.5M391 473.5C391 471.1 383.667 458.167 380 452M380 471.5C380.8 468.7 372.667 457.667 368.5 452.5"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_middle_chest)"
        @mouseover="activeArea = areas.back_middle_chest"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="
          data.back_middle_chest.selected ? areas.back_middle_chest.activeColor : areas.back_middle_chest.inactiveColor
        "
        :class="{ active: data.back_middle_chest.selected, hovered: activeArea == areas.back_middle_chest }"
        d="M134 281C130.32 268.324 129.418 259.63 129 242.5C192.853 249.009 228.806 249.202 293.5 243.5C293.646 260.344 293.477 269.525 288.5 281C286.953 305.036 285.984 313.208 288.5 329.5C258.244 349.57 163.733 349.866 134 329.5C135.513 307.785 134.88 301.724 134 281Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_middle_chest)"
        @mouseover="activeArea = areas.back_middle_chest"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :class="{ active: data.back_middle_chest.selected, hovered: activeArea == areas.back_middle_chest }"
        d="M212 256V324.5M129 242.5C129.418 259.63 130.32 268.324 134 281C134.88 301.724 135.513 307.785 134 329.5C163.733 349.866 258.244 349.57 288.5 329.5C285.984 313.208 286.953 305.036 288.5 281C293.477 269.525 293.646 260.344 293.5 243.5C228.806 249.202 192.853 249.009 129 242.5Z"
        stroke="black"
      />
      <path
        d="M157.5 487C174.7 497.475 191.59 495.54 202.5 491.459C203.191 491.2 203.858 490.933 204.5 490.66M218.03 490.66C228.801 495.245 246.74 498.139 265.03 487M218.03 490.66L211.684 536.5H294.5C307.092 498.491 307.207 478.208 293.765 444.5C294.627 431.084 292.522 412.458 291.53 398.5C228.839 406.747 193.691 406.785 131 398.5C130.009 412.458 127.903 431.084 128.765 444.5C115.323 478.208 116.173 498.491 128.765 536.5H211.265L204.5 490.66M218.03 490.66C212.467 493.748 209.527 493.498 204.5 490.66M218.03 490.66C215.124 489.639 213.615 488.994 211.5 487.5M204.5 490.66C208.024 489.997 209.65 489.374 211.5 487.5M211.5 487.5L211.265 427.5"
        stroke="black"
        fill="#a7a7a7"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_upper_right_leg)"
        @mouseover="activeArea = areas.back_upper_right_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="data.back_upper_right_leg.selected ? areas.back_upper_right_leg.activeColor : 'none'"
        :class="{ active: data.back_upper_right_leg.selected, hovered: activeArea == areas.back_upper_right_leg }"
        d="M293.765 444.5C294.627 431.084 292.522 412.458 291.53 398.5C257.5 402.5 234.5 405 211.265 404.699L211.5 487.5C213.615 488.994 215.124 489.639 218.03 490.66L211.684 536.5H294.5C307.092 498.491 307.207 478.208 293.765 444.5Z"
        stroke="black"
      />
      <path
        @click="eventClickOnGerericAreas(areas.back_upper_left_leg)"
        @mouseover="activeArea = areas.back_upper_left_leg"
        @mouseleave="activeArea = null"
        @mouseenter="setPosition"
        class="ax-selectable"
        :fill="data.back_upper_left_leg.selected ? areas.back_upper_left_leg.activeColor : 'none'"
        :class="{ active: data.back_upper_left_leg.selected, hovered: activeArea == areas.back_upper_left_leg }"
        d="M129.131 444C128.269 430.584 130.009 411.958 131 398C165.03 402 188.397 404.5 211.631 404.199L211.397 487C209.282 488.494 207.773 489.139 204.866 490.16L211 536.5H128.5C115.908 498.491 115.69 477.708 129.131 444Z"
        stroke="black"
      />
    </svg>
    <v-tooltip :value="!!activeArea" :position-x="tooltipPositionX" :position-y="tooltipPositionY" top>
      {{ tooltiplabel }}
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    height: String,
    width: String,
    value: Object,
    readOnly: Boolean,
  },
  computed: {
    tooltiplabel() {
      return this.activeArea?.label || ''
    },
  },
  methods: {
    buildEmptyDataObject() {
      return Object.values(this.areas).reduce(
        (acc, option) => ({
          ...acc,
          [option.key]: { selected: false, label: option.label },
        }),
        {},
      )
    },
    setPosition(e) {
      this.tooltipPositionX = e.clientX
      this.tooltipPositionY = e.clientY
    },
    eventClickOnGerericAreas(clickedArea) {
      this.data[clickedArea.key].selected = !this.data[clickedArea.key].selected
      if (this.data[clickedArea.key].selected) {
        this.data.area_total += clickedArea.weight
      } else {
        this.data.area_total -= clickedArea.weight
      }
      this.$emit('input', this.data)
    },
  },
  mounted() {
    this.data = { ...this.buildEmptyDataObject(), ...this.value, area_total: this.totalWeight }
    this.isMounted = true
  },
  data() {
    return {
      totalWeight: 0,
      isMounted: false,
      activeColor: '#ff0000',
      inactiveColor: '#fff',
      data: null,
      tooltipPositionX: null,
      tooltipPositionY: null,
      activeArea: null,
      areas: {
        face: {
          key: 'face',
          label: 'Face',
          selected: false,
          activeColor: 'rgba(25, 243, 191, 0.5)',
          inactiveColor: '#e0e0e0',
          weight: 8.5,
        },
        head: {
          key: 'head',
          label: 'Cabeça',
          selected: false,
          activeColor: 'rgba(25, 243, 191, 0.5)',
          inactiveColor: '#e0e0e0',
          weight: 8.5,
        },
        front_right_lower_arm: {
          key: 'front_right_lower_arm',
          label: 'Braço posterior inferior direito',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1,
        },
        front_right_upper_arm: {
          key: 'front_right_upper_arm',
          label: 'Braço posterior superior direito',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1.25,
        },
        front_right_middle_arm: {
          key: 'front_right_middle_arm',
          label: 'Braço posterior médio direito',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1.25,
        },
        front_left_lower_arm: {
          key: 'front_left_lower_arm',
          label: 'Braço posterior inferior esquerdo',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1,
        },
        front_left_upper_arm: {
          key: 'front_left_upper_arm',
          label: 'Braço posterior superior esquerdo',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1.25,
        },
        front_left_middle_arm: {
          key: 'front_left_middle_arm',
          label: 'Braço posterior médio esquerdo',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1.25,
        },
        back_right_lower_arm: {
          key: 'back_right_lower_arm',
          label: 'Braço anterior inferior direito',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1,
        },
        back_right_upper_arm: {
          key: 'back_right_upper_arm',
          label: 'Braço anterior superior direito',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1.25,
        },
        back_right_middle_arm: {
          key: 'back_right_middle_arm',
          label: 'Braço anterior médio direito',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1.25,
        },
        back_left_lower_arm: {
          key: 'back_left_lower_arm',
          label: 'Braço anterior inferior esquerdo',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1,
        },
        back_left_upper_arm: {
          key: 'back_left_upper_arm',
          label: 'Braço anterior superior esquerdo',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1.25,
        },
        back_left_middle_arm: {
          key: 'back_left_middle_arm',
          label: 'Braço anterior médio esquerdo',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1.25,
        },
        front_right_hand: {
          key: 'front_right_hand',
          label: 'Palma da mão direita',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1,
        },
        back_right_hand: {
          key: 'back_right_hand',
          label: 'Dorço da mão direita',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1,
        },
        front_left_hand: {
          key: 'front_left_hand',
          label: 'Palma da mão esquerda',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1,
        },
        back_left_hand: {
          key: 'back_left_hand',
          label: 'Dorço da mão esquerda',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1,
        },
        front_upper_chest: {
          key: 'front_upper_chest',
          label: 'Peito',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 6,
        },
        front_middle_chest: {
          key: 'front_middle_chest',
          label: 'Tórax',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 6,
        },
        front_lower_chest: {
          key: 'front_lower_chest',
          label: 'Barriga',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 6,
        },
        back_upper_chest: {
          key: 'back_upper_chest',
          label: 'Pescoço',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 6,
        },
        back_middle_chest: {
          key: 'back_middle_chest',
          label: 'Costas',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 6,
        },
        back_lower_chest: {
          key: 'back_lower_chest',
          label: 'Lombar',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 6,
        },
        genitalia: {
          key: 'genitalia',
          label: 'Genitália',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1,
        },
        back_upper_right_leg: {
          key: 'back_upper_right_leg',
          label: 'Coxa anterior direita',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1,
        },
        back_middle_right_leg: {
          key: 'back_middle_right_leg',
          label: 'Joelho anterior direito',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 2.33,
        },
        back_lower_right_leg: {
          key: 'back_lower_right_leg',
          label: 'Pé anterior direito',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 2.33,
        },
        back_upper_left_leg: {
          key: 'back_upper_left_leg',
          label: 'Coxa anterior esquerda',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 1,
        },
        back_middle_left_leg: {
          key: 'back_middle_left_leg',
          label: 'Joelho anterior esquerdo',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 2.33,
        },
        back_lower_left_leg: {
          key: 'back_lower_left_leg',
          label: 'Pé anterior esquerdo',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 2.33,
        },
        front_upper_right_leg: {
          key: 'front_upper_right_leg',
          label: 'Coxa posterior direita',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 2.33,
        },
        front_middle_right_leg: {
          key: 'front_middle_right_leg',
          label: 'Joelho posterior direito',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 2.33,
        },
        front_lower_right_leg: {
          key: 'front_lower_right_leg',
          label: 'Pé posterior direito',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 2.33,
        },
        front_upper_left_leg: {
          key: 'front_upper_left_leg',
          label: 'Coxa posterior esquerda',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 2.33,
        },
        front_middle_left_leg: {
          key: 'front_middle_left_leg',
          label: 'Joelho posterior esquerdo',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 2.33,
        },
        front_lower_left_leg: {
          key: 'front_lower_left_leg',
          label: 'Pé posterior esquerdo',
          selected: false,
          activeColor: '#7EE989',
          inactiveColor: '#a7a7a7',
          weight: 2.33,
        },
      },
    }
  },
}
</script>

<style scoped>
.areas {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.ax-selectable {
  cursor: pointer;
  transition: all 0.1s ease-in-out;
}
.ax-selectable.hovered:not(.active) {
  fill: #9c9c9c;
}
.ax-label {
  position: fixed;
  background: #aaa021;
  color: white;
  padding: 4px 14px;
  font-size: 0.8rem;
  border-radius: 8px;
  box-shadow: 0 0 3px 0 #3a3a3a42;
  user-select: none;
}
.ax-thumbnails {
  display: flex;
}
.ax-thumbnails .ax-thumbs .ax-thumb-item {
  height: 106px;
  width: 106px;
  border-radius: 5px;
  background: #e8e8e870;
  margin: 1rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
}
.ax-thumbnails .ax-thumbs .ax-thumb-item:before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.ax-thumbnails .ax-thumbs .ax-thumb-item.active {
  border: 2px solid #aba022;
}
.ax-thumbnails .ax-thumbs .ax-thumb-item:hover {
  border: 2px solid rgba(171, 160, 34, 0.6);
}
.ax-thumbnails .ax-thumbs .ax-thumb-item:first-of-type {
  margin-top: 0;
}
.ax-selected-areas {
  padding: 1rem 1.8rem;
  border-left: 1px solid #dee2e6;
  width: 250px;
}
.ax-selected-areas > p {
  font-weight: bold;
}
.ax-selected-areas > ul {
  list-style: none;
  padding: 0;
  margin: 1.4rem 0;
}
.ax-selected-areas > ul > li {
  display: flex;
  justify-content: space-between;
  margin: 0 0 0.8rem;
}
.ax-selected-areas > ul > li > span {
  width: 100%;
}
.ax-selected-areas > ul > li > i {
  color: #e0e0e0;
  cursor: pointer;
}
.items-questions {
  align-self: center;
  height: fit-content;
}

.icon-page {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-7%);
  transform: translateY(-50%);
}

.answer-areas {
  background: #f6f6f6;
  padding-top: 0.1rem;
  padding-bottom: 0.7rem;
  margin-top: 0.5rem !important;
}

.answer-areas-position {
  margin-left: 40px;
}

.answer-text-position {
  margin-left: 25px;
}

body {
  color: #636c72;
}

body nick-checkbox .form-group,
.page-router-container nick-checkbox .form-group {
  margin: 0 !important;
  float: left;
  height: auto;
}

.form-group {
  margin-bottom: 0rem;
}

.page-router-container .nick-radio-options .nick-radio-option {
  width: 33.3333%;
  margin: 0px;
}

.ax-selected-areas {
  width: 300px;
}

label {
  margin-bottom: 0px;
}

.modal-dialog {
  max-width: 650px;
}

#items-wrapper {
  width: 100%;
}

#items {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
}

.item {
  flex: none;
  width: 100%;
  height: 100%;
  scroll-snap-align: start;
  pointer-events: none;
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
